import {
  InjectedLLMJudge,
  LLMJudgeError,
  type InjectedInvoker,
} from "./shared.js";

/**
 * Claude Code host adapter for `LLMJudge`.
 *
 * Claude Code's natural surface for a single-shot decision query is a
 * **sub-agent tool call** — a separate, ephemeral agent invoked by the outer
 * session with a focused prompt, returning its single answer. The adapter
 * does not know how to invoke a sub-agent itself (that is Claude Code runtime
 * territory); the host injects an invoker callback at construction time, and
 * the shared {@link InjectedLLMJudge} base handles prompt framing + tolerant
 * response parsing on top of it.
 *
 * The invoker callback is intentionally minimal — a single async function
 * that takes a string and returns a string. Hosts that want to thread
 * additional metadata (session id, tool budget) can capture them in the
 * closure when they create the invoker.
 */

/** Claude Code's sub-agent invoker — a `prompt in, string out` call. */
export type ClaudeCodeSubAgentInvoker = InjectedInvoker;

export class ClaudeCodeLLMJudgeError extends LLMJudgeError {
  constructor(message: string, raw?: string) {
    super(message, raw);
    this.name = "ClaudeCodeLLMJudgeError";
  }
}

export class ClaudeCodeLLMJudge extends InjectedLLMJudge {
  readonly host = "claude-code";

  protected override makeError(message: string, raw?: string): Error {
    return new ClaudeCodeLLMJudgeError(message, raw);
  }
}
